<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage === '' && datosRecibidos">
    <div class="table-header">
        <div class="header-content">
            <span>REGISTRO DE ALARMAS ACTIVAS</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>

        <span class="font14">Registro de alarmas activas actualmente DataBeer</span>

        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="descargarExcel()">
                <mat-icon>download</mat-icon>
                <span>Exportar a Excel</span>
            </button>
        </mat-menu>
    </div>

    <div class="mat-elevation-z8">
        <div class="top-container-container">
            <div class="top-container">
                <mat-form-field class="custom1">
                    <mat-label>Filtrar</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput (keyup)="applyFilter()" placeholder="Ex.nombre" [(ngModel)]="filterValue">
                </mat-form-field>
            </div>

            <div class="estado-container">
                <span class="custom2">Modalidad de alarma: </span>
                <mat-form-field class="custom3">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedModalidad" name="est" (selectionChange)="onModalidadChange()">
                      <mat-option *ngFor="let est of modalidad" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="dev_reference">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Ref. Dispositivo </th>
                <td mat-cell *matCellDef="let element" class="dev-reference"> {{element.dev_reference}} </td>
            </ng-container>

            <ng-container matColumnDef="dev_label">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre Disp. </th>
                <td mat-cell *matCellDef="let element" class="router-cell" routerLink="/dispositivo/ver/{{element.dev_id}}"> {{element.dev_label}} </td>
            </ng-container>

            <ng-container matColumnDef="est_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Establecimiento </th>
                <td mat-cell *matCellDef="let element" class="router-cell" routerLink="/establecimiento/{{element.est_id}}"> {{element.est_name}} </td>
            </ng-container>

            <!--<ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Alarma ID </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.id}} </td>
            </ng-container>-->

            <ng-container matColumnDef="f_inicio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Inicio </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.f_inicio}} </td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                <td mat-cell *matCellDef="let element" class="cell">{{element.type}}</td>
            </ng-container>

            <ng-container matColumnDef="alarm_range">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Rango de Alarma </th>
                <td mat-cell *matCellDef="let element" class="cell">{{element.alarm_range}}</td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator 
            [pageSizeOptions]="[20,40,80]" 
            showFirstLastButtons 
            aria-label="Elige una página"
            class="custom4">
        </mat-paginator>
    </div>
</ng-container>
